import { MenuItems } from "../types";

export const flattenItems = (items: MenuItems): MenuItems => {
  return items.reduce<MenuItems>((acc, item) => {
    acc.push(item);
    if (item.children?.length) {
      acc.push(...flattenItems(item.children));
    }
    return acc;
  }, []);
};

export const buildParentMap = (
  items: MenuItems,
  parentId: string | null = null,
  map: Map<string, string | null> = new Map(),
): Map<string, string | null> => {
  for (const item of items) {
    map.set(item.id, parentId);
    if (item.children?.length) {
      buildParentMap(item.children, item.id, map);
    }
  }
  return map;
};

export const getRange = (items: MenuItems, fromId: string, toId: string) => {
  const flat = flattenItems(items);
  const parentMap = buildParentMap(items);

  const fromItem = flat.find((i) => i.id === fromId);

  if (!fromItem || fromItem.value === null) return [];

  const targetParent = parentMap.get(fromId);

  const sameLevel = flat.filter(
    (i) => parentMap.get(i.id) === targetParent && i.value !== null,
  );

  const fromIndex = sameLevel.findIndex((i) => i.id === fromId);
  let toIndex = sameLevel.findIndex((i) => i.id === toId);

  if (toIndex === -1) {
    const flatFromIndex = flat.findIndex((i) => i.id === fromId);
    const flatToIndex = flat.findIndex((i) => i.id === toId);
    toIndex = flatFromIndex < flatToIndex ? sameLevel.length - 1 : 0;
  }

  if (fromIndex === -1) return [];

  const [start, end] =
    fromIndex < toIndex ? [fromIndex, toIndex] : [toIndex, fromIndex];

  return sameLevel.slice(start, end + 1).map((i) => i.id);
};
